import type { FC } from 'react';

import cn from 'classnames';

import { extractYoutubeVideoIdFromUrl } from '../../../../../utils/extractYoutubeVideoIdFromUrl';

import type { LinkEmbedVendor } from './types';

interface YoutubeProps {
  data: { videoId?: string } | null;
  className?: string;
}

export const Youtube: FC<YoutubeProps> = ({ data, className }) => {
  const videoId = data?.videoId;
  if (!videoId) return null;

  const embedUrl = `https://www.youtube.com/embed/${videoId}`;

  return (
    <div className={cn('relative w-full rounded-xl overflow-hidden', className)} style={{ paddingBottom: '56.25%' }}>
      <iframe
        className="absolute inset-0 size-full"
        src={embedUrl}
        loading="lazy"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title="YouTube video"
      />
    </div>
  );
};

// biome-ignore lint/style/useComponentExportOnlyModules: paste-detection lives alongside the vendor's view
export const youtubeVendor: LinkEmbedVendor = {
  match: (pastedText) => {
    const videoId = extractYoutubeVideoIdFromUrl(pastedText);
    return videoId ? { videoId } : null;
  },
};
